export default __webpack_public_path__ + "static/media/024.a4800075.jpg";